import { BASE_IMPORT_DATA } from "@/Modals/WebDataManagement/MasterData/BaseImport/baseImportData";
import BrandModal from "@/Modals/WebDataManagement/MasterData/Brands/Modal";
import MasterDataBaseTable from "../MasterDataBaseTable";
import React from "react";
import { brandsMasterDataApi } from "@/apis/apis";
import { columns } from "./Columns";

export default function BrandsPage() {
  return (
    <MasterDataBaseTable
      label="Brand"
      apiURL={brandsMasterDataApi}
      columns={columns()}
      ModalComponent={BrandModal}
      importData={BASE_IMPORT_DATA.BRANDS}
      hideLocalizationColumn
      enableStatus={false}
    />
  );
}
